// src/components/ProductsPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductsPage.css";

const ProductsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="products-page">
      <header className="products-header">
        <h1>Our Products</h1>
        <p>Select a category to explore our offerings.</p>
        {/*<div className="promo-code-banner">
          <h3>Limited Time Offer: 15% OFF</h3>
          <p>
            Use promo code <span className="promo-code">RelaxRefresh15</span> at
            checkout for 15% off any membership or studio pacakage purchased
            before April 30, 2025.
          </p>
        </div>*/}
      </header>
      <section className="products-cards">
        <div className="product-card" onClick={() => navigate("/memberships")}>
          <h2>Memberships</h2>
          <p>Explore our exclusive memberships for wellness and relaxation.</p>
          <button>View Memberships</button>
        </div>
        {/* Studio Packages now available */}
        <div
          className="product-card"
          onClick={() => navigate("/studio-packages")}
        >
          <h2>Studio Packages</h2>
          <p>Explore our curated packages for optimal wellness results.</p>
          <button>View Packages</button>
        </div>
        {/* Single Sessions now available */}
        <div
          className="product-card"
          onClick={() => navigate("/drop-in-sessions")}
        >
          <h2>Single Sessions</h2>
          <p>Book individual sauna or red light therapy sessions.</p>
          <button>View Sessions</button>
        </div>
        <div className="product-card" onClick={() => navigate("/gift-cards")}>
          <h2>Gifts and Gift Cards</h2>
          <p>Gift a session or purchase a Diviti Adora Gift Card.</p>
          <button>View Gift Options</button>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
